import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import Script from "next/script";
const buildRiddleUrl = (riddleId, staticHeight, lazyImages) => {
  const baseUrl = `https://riddle.com/embed/a/${riddleId}`;
  const params = new URLSearchParams();
  if (typeof staticHeight !== "undefined") {
    params.append("staticHeight", staticHeight.toString());
  }
  if (typeof lazyImages !== "undefined") {
    params.append("lazyImages", lazyImages.toString());
  }
  const queryString = params.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
const RiddleEmbed = ({
  riddleId,
  initialHeight = 400,
  staticHeight,
  lazyImages
}) => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(Script, { id: "riddle-embed-script", src: "https://riddle.com/embed/build-embedjs/embedV2.js", strategy: "afterInteractive" }),
  /* @__PURE__ */ jsx(Box, { className: "riddle2-wrapper", css: {
    margin: "0 auto",
    maxWidth: "100%",
    width: "640px"
  }, "data-testid": "riddle-embed-wrapper", children: /* @__PURE__ */ jsx(Box, { asChild: true, css: {
    width: "100%",
    display: "block"
  }, children: /* @__PURE__ */ jsx("iframe", { src: buildRiddleUrl(riddleId, staticHeight, lazyImages), allow: "autoplay", referrerPolicy: "strict-origin", title: "Riddle Embed", style: {
    height: initialHeight,
    border: 0
  } }) }) })
] });
export {
  RiddleEmbed as default
};
